import { HashLink } from "../../../../src/components/link";
import googleComic from "../../../../src/images/working_for_google.png";
import * as React from 'react';
export default {
  HashLink,
  googleComic,
  React
};